export default "__VITE_ASSET__CQN_pmru__"